var ttFilterNav = {
  init: function () {
    var pdcs_el = $('#products');
    var filter_el = $('.tt-filter');
    var bar_el = filter_el.find('.filterbar-wrap');
    var title_btn = filter_el.find('.filterbar-btn');
    var size_md_btn = $('#thumb_size_md');
    var size_xs_btn = $('#thumb_size_xs');
    // var phone_btn = $('.tt-filter-btn-phone');
    // var cookie_thumb_size = tt_getCookie('tt_pdc_thumb_size');

    var toggle_filter = function () {
      body_el.toggleClass('tt-filter-active');
      headerNav.closeAll();

      $(window).off('click.filternav');

      if (body_el.hasClass('tt-filter-active')) {
        $(window).on('click.filternav', function (e) {
          // if ( !$(e.target).closest('.tt-filter').length && !$(e.target).closest('#filter-main').length ) {
          if ( !$(e.target).closest('.filterbar-btn').length && !$(e.target).closest('#filter-main').length && !$(e.target).closest('#phonefilter').length ) {
            body_el.removeClass('tt-filter-active');
          }
        });

        bar_el.find('input').on('focus', function () {
          body_el.removeClass('tt-filter-active');
        });
      }
    }

    title_btn.each(function () {
      var th = $(this);

      th.off('click').on('click', toggle_filter);
    });

    size_md_btn.off('click').on('click', function () {
      size_xs_btn.removeClass('active');
      $(this).addClass('active');
      pdcs_el.removeClass('thumb_size_xs');
      tt_setcookie('tt_pdc_thumb_size', 'md', 30);
    });

    size_xs_btn.off('click').on('click', function () {
      size_md_btn.removeClass('active');
      $(this).addClass('active');
      pdcs_el.addClass('thumb_size_xs');
      tt_setcookie('tt_pdc_thumb_size', 'xs', 30);
    });

    // phone_btn.off('click').on('click', toggle_filter);
  }
}